<template lang="pug">
.dashboard
    h2.dashboard__title {{ inOrder.project_name }}
    h3.dashboard__subtitle {{ $t('strings.created') }} {{ inOrder.created_at }}
    Chart(:invoices="selectedInvoices")
    Breakdown(:invoices="invoices" :selectedInvoices="selectedInvoices" @selected="selected")
    Balance(:invoices="selectedInvoices")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('InOrders')

export default {
  name: 'Dashboard',
  components: {
    Chart: () =>
            import('@/components/in-order/Payments/Dashboard/Chart.vue'),
    Breakdown: () =>
            import('@/components/in-order/Payments/Dashboard/Breakdown.vue'),
    Balance: () =>
            import('@/components/in-order/Payments/Dashboard/Balance.vue')
  },
  data: () => ({
    selectedInvoices: [],
    invoiceSelected: false
  }),
  created () {
    this.selectedInvoices = this.invoices
  },
  computed: {
    ...mapGetters(['inOrder', 'invoices'])
  },
  methods: {
    selected (invoice) {
      if (
        this.invoiceSelected &&
                !!this.selectedInvoices.length &&
                this.selectedInvoices[0].id === invoice.id
      ) {
        this.selectedInvoices = this.invoices
        this.invoiceSelected = false
      } else {
        this.selectedInvoices = [invoice]
        this.invoiceSelected = true
      }
    }
  }
}
</script>

<style lang="scss">
.dashboard {
    margin: 1rem 0;
    &__title {
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 1rem;
    }

    &__subtitle {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 1rem;
    }
}
</style>
